import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setCodOptionalServicePrice } from '../../../../../../actions/registerShipmentActions';
import { getCodFormCustomPrice } from '../../../../../../helpers/apiHelpers/registerShipmentHelpers';
import FormikFieldWrapper from '../../../../../base/forms/formikFieldWrapper';
import { StyledFormikField } from '../../../../../base/forms/input';
import { Column, Columns } from '../../../../../base/grid';

interface Props {
	amount: string;
}

const CodForm: FC<Props> = ({ amount }) => {
	const dispatch = useDispatch<any>();
	const { t } = useTranslation('registerShipment');
	const { codOptionalServiceCustomPrice } = useSelector(({ registerShipmentReducer }) => registerShipmentReducer);

	useEffect(() => {
		const price = getCodFormCustomPrice(amount);
		if (price !== codOptionalServiceCustomPrice) dispatch(setCodOptionalServicePrice(price));
	}, [amount, dispatch, codOptionalServiceCustomPrice]);

	return (
		<>
			<Columns>
				<Column tablet={1 / 2}>
					<FormikFieldWrapper
						name="codAmount"
						label={t('step-optional-services.amount')}
						smallLabel
						languageComponent="registerShipment">
						<StyledFormikField
							type="text"
							id="codAmount"
							name="codAmount"
							placeholder={t('step-optional-services.amount') + '*'}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column tablet={1 / 2}>
					<FormikFieldWrapper
						name="codSsn"
						label={t('step-optional-services.ssn-recipient')}
						smallLabel
						languageComponent="registerShipment">
						<StyledFormikField
							type="text"
							id="codSsn"
							name="codSsn"
							placeholder={t('step-optional-services.ssn-recipient') + '*'}
						/>
					</FormikFieldWrapper>
				</Column>
			</Columns>
			<Columns>
				<Column tablet={1 / 3}>
					<FormikFieldWrapper
						name="codBank"
						label={t('step-optional-services.bank')}
						smallLabel
						languageComponent="registerShipment">
						<StyledFormikField
							type="text"
							id="codBank"
							name="codBank"
							placeholder={t('step-optional-services.bank') + '*'}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column tablet={1 / 3}>
					<FormikFieldWrapper
						name="codAccountType"
						label={t('step-optional-services.account-type')}
						smallLabel
						languageComponent="registerShipment">
						<StyledFormikField
							type="text"
							id="codAccountType"
							name="codAccountType"
							placeholder={t('step-optional-services.account-type') + '*'}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column tablet={1 / 3}>
					<FormikFieldWrapper
						name="codAccount"
						label={t('step-optional-services.account')}
						smallLabel
						languageComponent="registerShipment">
						<StyledFormikField
							type="text"
							id="codAccount"
							name="codAccount"
							placeholder={t('step-optional-services.account') + '*'}
						/>
					</FormikFieldWrapper>
				</Column>
			</Columns>
			<Columns>
				<Column>
					<FormikFieldWrapper
						name="codReference"
						label={t('step-optional-services.reference')}
						smallLabel
						languageComponent="registerShipment">
						<StyledFormikField
							type="text"
							id="codReference"
							name="codReference"
							placeholder={t('step-optional-services.reference')}
						/>
					</FormikFieldWrapper>
				</Column>
			</Columns>
		</>
	);
};

export default CodForm;
